// import { number/Result";
// import { FilterChip } from "components/Tables/TableFilters/TableFilters";
// import { FilterChipType } from "components/TableFilters/FilterType";
import { action, makeObservable, observable, runInAction } from "mobx";
type FilterChipType = any;
export interface IBaseStoreClass {
  filters: FilterChipType[];
  page: number;
  take: number;
  totalItemCount: number;
  totalPageCount: number;
  addFilter: (value: FilterChipType) => void;
  removeFilter: (index: number) => void;
  filtersQueryStr: (filters: FilterChipType[]) => string;
  clearFilters: () => void;
}

export class BaseStoreClass implements IBaseStoreClass {
  filters: FilterChipType[] = [];

  isLoading = true;

  // pagination
  page: number = 1;
  take: number = 10;
  totalItemCount: number = 0;
  totalPageCount: number = 0;
  constructor() {
    makeObservable(this, {
      filters: observable,
      page: observable,
      take: observable,
      totalItemCount: observable,
      totalPageCount: observable,
      isLoading: observable,
      addFilter: action,
      clearFilters: action,
    });
  }
  addFilter = (value: FilterChipType) => {
    if (this.filters.find((f) => f.id === value.id)) {
      this.filters = this.filters.map((f) => (f.id === value.id ? value : f));
      return;
    }
    this.filters.push(value);
  };

  removeFilter = (index: number) => this.filters.splice(index, 1);

  clearFilters = () => {
    this.filters = [];
  };

  filtersQueryStr = (filters: FilterChipType[]) => {
    let q = "";
    filters.forEach((f) => (q += `&${f.id}=${f.value}`));
    return q;
  };

  // =============
  protected fetchData = async <T>(
    fetchFn: (
      param: string | undefined,
      page: number,
      count: number
    ) => Promise<T>,
    onSuccess?: (res: T) => void,
    params?: string
  ) => {
    try {
      this.isLoading = true;
      let data = await fetchFn(params, this.page, this.take);
      if (onSuccess) {
        runInAction(() => onSuccess(data));
      }
      return data;
    } catch (ex) {
      // throw Error(ex);
    } finally {
      runInAction(() => (this.isLoading = false));
    }
  };
}
